import React, { forwardRef } from 'react';
import { Card } from 'react-bootstrap';

const Instructions = forwardRef((props, ref) => {
 return (
  <Card className="mb-3 mb-lg-0" id="instructions" ref={ref}>
   <Card.Header className="bg-light">
    <h5 className="mb-0">Agregados</h5>
   </Card.Header>
   <Card.Body>
    <p className="mb-0 ps-3">
     Además, reconoce que podemos compartir información necesaria con autoridades gubernamentales y terceros en respuesta a una
     citación, una orden judicial, una solicitud de información de una agencia reguladora, un requerimiento de cumplimiento de la
     ley o una investigación relacionada con la seguridad pública. Finalmente, reconoce que podemos transferir información en caso
     de una fusión, adquisición o venta de activos de la empresa.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Declinación de garantías</h6>
    <p className="mb-0 ps-3">
     Los Servicios se proporcionan "tal cual" y "según disponibilidad". No hacemos representaciones o garantías de ningún tipo,
     expresas o implícitas, en relación con los Servicios o el uso de los mismos, incluyendo, sin limitación, garantías de
     comerciabilidad, aptitud para un propósito particular, título y no infracción.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Limitación de responsabilidad</h6>
    <p className="mb-0 ps-3">
     En ningún caso, incluyendo negligencia, nos responsabilizaremos por cualquier daño indirecto, incidental, especial,
     consecuente o ejemplar o por cualquier pérdida de ingresos, ganancias o contratos, daños a la reputación o pérdida de
     información o datos.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Modificaciones a los Términos</h6>
    <p className="mb-0 ps-3">
     Nos reservamos el derecho a modificar estos Términos en cualquier momento. Si hacemos cambios materiales a los Términos, le
     notificaremos por correo electrónico o mediante un aviso en el Servicio antes de que los cambios entren en vigencia. Al
     continuar accediendo o utilizando el Servicio después de los cambios, acepta estar vinculado por los Términos modificados.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Resolución de disputas</h6>
    <p className="mb-0 ps-3">
     Cualquier disputa relacionada con los Servicios o estos Términos será resuelta mediante arbitraje vinculante y se regirá por
     las reglas de arbitraje de la Asociación Americana de Arbitraje, en su versión más reciente.
    </p>

    <hr className="my-4" />
    <h6 className="text-primary">Acuerdo completo</h6>
    <p className="mb-0 ps-3">
     Estos Términos, junto con la Política de privacidad y cualquier otro acuerdo que haya sido aceptado por usted y nosotros,
     constituyen el acuerdo completo entre usted y nosotros en relación con el uso de nuestro Servicio. Cualquier término o
     condición que sea impuesto en cualquier oferta o acuerdo adicional que haga con nosotros será suplementario a los Términos y,
     en caso de conflicto, prevalecerán los términos de este acuerdo. En el caso de que alguna disposición de estos Términos sea
     considerada inválida o inaplicable, esa disposición se limitará o se eliminará en la medida mínima necesaria y las
     disposiciones restantes permanecerán en pleno vigor y efecto. La falta de nosotros de hacer cumplir cualquier derecho o
     disposición de estos Términos no constituirá una renuncia a ese derecho o disposición. Todas las notificaciones, solicitudes,
     demandas y otras comunicaciones que desee hacernos deben ser enviadas por correo electrónico y serán consideradas recibidas y
     recibidas dentro de los 3 días siguientes a la fecha de envío. Estos Términos se regirán e interpretarán de acuerdo con las
     leyes del país en el que se encuentre nuestro Servicio, sin tener en cuenta su conflicto de leyes. Cualquier acción legal
     relacionada con estos Términos o el uso de nuestro Servicio será presentada exclusivamente en los tribunales del país en el
     que se encuentre nuestro Servicio y usted acepta someterse a la jurisdicción personal de esos tribunales.
    </p>
    <hr className="my-4" />
    <p>Last update: 04 Nov 2020</p>
   </Card.Body>
  </Card>
 );
});

export default Instructions;
